import React, { useContext } from 'react';
import { Typography, Button } from 'antd';
import LangContext from '../../../context/LangContext';

const Contact = () => {

    const { currentLangData } = useContext(LangContext);

    const { Title } = Typography;

    return(
        <div id="contacto" className="capabilities-container main-container" style={{ paddingTop: '4rem', paddingBottom: '6rem', width: '100%', height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} >
            <div style={{ maxWidth: '48rem', height: 'auto', padding: '2rem 0rem', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column' }} >
                <Title className="main-title-color" style={{ paddingBottom: '.45em', fontSize: '2.55rem', textAlign: 'center' }}>
                    {currentLangData.CONTACTO.title}
                </Title>
                <span className="montserrat accent-title-color" style={{ fontSize: '1.3rem', textAlign: 'center', paddingBottom: '1.45em', }} >
                    <div className="pulse" style={{ marginTop: '-.2em', marginRight: '.55em' }} ></div> 
                    {currentLangData.CONTACTO.subtitle}
                </span>
                <a href="mailto:rodd.sal23@gmail.com" style={{ textDecoration: 'none' }}>
                    <Button type="primary" shape="round" size="large" className="main-cta" style={{ height: 50 }} >
                        <span className="no-margin montserrat" style={{ fontSize: '1.15rem' }}>
                            {currentLangData.NAVIGATION.sendMessage}
                        </span>  
                    </Button>
                </a>
            </div>
        </div>
    )
}

export default Contact;